module.exports = __webpack_public_path__ + "a1daf905e286620507167f4f7c69f950.svg";